import axios from "axios";
import { useMutation } from "react-query";

const TRANSCRIPTION_SERVICES = {
  sarvam: "/api/transcription/sarvam/initiate",
  elevenlabs: "/api/transcription/elevenlabs/initiate",
};

export const DEFAULT_TRANSCRIPTION_SERVICE = "sarvam";

/**
 * Hook that returns a mutation function to initiate transcription for an
 * uploaded audio file, against whichever service the block is configured with.
 * Designed to be injected into oolib's AudioInput via OolibThemeProvider.
 *
 * Usage (inside AudioInput via theme):
 *   const { mutate: initiate } = theme.useInitiateTranscription()
 *   initiate({ service, audioUrl, audioFilename, target, options })
 *
 * `service` defaults to "sarvam" so existing templates (which have no service
 * configured) keep their current behaviour.
 */
export const useInitiateTranscription = () => {
  return useMutation(
    ({ service, audioUrl, audioFilename, target, options }) => {
      const url =
        TRANSCRIPTION_SERVICES[service] ||
        TRANSCRIPTION_SERVICES[DEFAULT_TRANSCRIPTION_SERVICE];

      return axios.post(
        url,
        { audioUrl, audioFilename, target, options },
        { headers: { "Content-Type": "application/json" } }
      );
    },
  );
};

/**
 * @deprecated Use `useInitiateTranscription` instead, which supports both
 * Sarvam and ElevenLabs. Kept as an alias so any existing caller still works.
 */
export const useInitiateSarvamTranscription = useInitiateTranscription;
